import { useEffect } from 'react';
import { useAxios } from 'src/hooks/use-axios';
import { useCognito } from 'src/hooks/use-cognito';
import { removeStoredMonolithJwt } from 'src/utils/axios-instance';

const url = `${PRISMA_CONFIG.oldBackendUrl}/auth/logout`;

export function useLogout() {
  const cognito = useCognito();

  const logout = useAxios(
    (axios, signal) =>
      axios.request<true>({
        signal,
        url,
      }),
    { neededOnPageLoad: false }
  );

  useEffect(() => {
    if (!logout.response) return;

    removeStoredMonolithJwt(cognito);
    location.replace(`${PRISMA_CONFIG.oldFrontendUrl}/#/start`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logout.response]);

  return logout;
}
